import type { Capabilities } from '@rtkwlf/rendall';

import type { FeatureConfig } from '@platform/client/features';

import { LegacyCapabilitiesGuard } from '@packages/components/capabilities/legacy-capabilities-guard';
import i18n from '@packages/core/i18n';
import { hasAnyRequiredProperty } from '@packages/utils/has-any-required-property';

const reportsCapability: Partial<Capabilities> = {
  canViewAllTickets: true,
};

export default {
  routes: [
    {
      path: 'reports',
      element: <LegacyCapabilitiesGuard capabilities={reportsCapability} />,
      children: [
        {
          index: true,
          lazy: () => import('./pages/reportList/ReportList.page'),
        },
        {
          path: ':reportId',
          lazy: () => import('./pages/reportList/ReportDetails.page'),
        },
        {
          path: 'scheduled',
          lazy: () =>
            import('./pages/scheduledReport/ScheduledReportList.page'),
        },
      ],
    },
  ],
  navigation: ({ legacyCapabilities }) => {
    const hasReportsAccess =
      legacyCapabilities &&
      hasAnyRequiredProperty(reportsCapability, legacyCapabilities);

    if (!hasReportsAccess) return {};

    return {
      reporting: {
        reportHistory: {
          title: i18n.t('reports:menu.reportHistory'),
          segment: '/reports',
          matchSegmentOnly: true,
        },
        reportSchedules: {
          title: i18n.t('reports:menu.reportSchedules'),
          segment: '/reports/scheduled',
        },
      },
    };
  },
} satisfies FeatureConfig;
